


import { useState } from "react";
import { NavLink } from "react-router-dom";

function Waitlist() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "", // "user" or "serviceProvider"
  });

  const handleCheckboxChange = (role) => {
    setFormData((prev) => ({
      ...prev,
      role: prev.role === role ? "" : role,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.role
    ) {
      alert("Please fill all fields and select a role.");
      return;
    }

    try {
      const response = await fetch(
        "https://pulo-api.onrender.com/api/waitlist",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        alert("Successfully joined the waitlist!");
        // Optionally reset form
        setFormData({ firstName: "", lastName: "", email: "", role: "" });
      } else {
        alert(result.message || "Failed to join waitlist.");
      }
    } catch (error) {
      alert("An error occurred. Please try again later.");
      console.error(error);
    }
  };

  return (
    <div>
      <div className="p-4">
        <div >
          <NavLink to="/">
            <img src="/images/logo.png" alt="Logo" className="w-[20%] max-w-[100px] md:w-[30%] sm:w-[40%]"  />
          </NavLink>
        </div>

        <div className="flex flex-col items-center text-center gap-2 w-[90%] max-w-[600px] my-4 mx-auto mb-12">
          <h1>Join Waitlist</h1>
          <p>
            Be the first to experience seamless journeys with personalized
            stays, rides guided travel assistants
          </p>
        </div>

        <div className="my-4 bg-[#61013b] p-4 flex items-center justify-between gap-4 rounded-xl max-md:flex-col max-md:gap-6">
          <div className="text-white flex flex-col gap-4">
            <h4>What You Get When You Join the Waitlist:</h4>
            <p>
              . Early access to exclusive deals on accommodations, rides & guide
            </p>
            <p>. Priority booking before the general launch</p>
            <p>
              . Personalized travel recommendations tailored to your preferences
            </p>
            <p>. Special discounts & rewards for early adopters</p>
          </div>

          <img
            src="./images/rac.png"
            alt="avatar"
            className="w-[40%] rounded-xl max-md:w-full"
          />
        </div>

        <h2 className="text-center my-8">
          Join waitlist for early access and exclusive perks!
        </h2>

        <form>
          <div className="flex flex-col gap-4 w-[90%] max-w-[500px] my-4 mx-auto">
            <div className="flex flex-col gap-2">
              <label>First Name</label>
              <input
                type="text"
                name="firstName"
                placeholder="Enter first name"
                value={formData.firstName}
                onChange={handleInputChange}
                className="p-4 rounded-md outline-none border border-black w-full"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label>Last Name</label>
              <input
                type="text"
                name="lastName"
                placeholder="Enter last name"
                value={formData.lastName}
                onChange={handleInputChange}
                className="p-4 rounded-md outline-none border border-black w-full"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label>Email address</label>
              <input
                type="email"
                name="email"
                placeholder="e.g. xyg@gmail.com"
                value={formData.email}
                onChange={handleInputChange}
                className="p-4 rounded-md outline-none border border-black w-full"
              />
            </div>
          </div>

          <div className="flex gap-4 my-8 mx-auto w-[90%] max-w-[500px] flex-wrap">
            <input type="checkbox" />
            <p>Get notified about early access offers</p>
          </div>

          <div className="flex flex-col items-center justify-center gap-4 my-4 mx-auto font-bold">
            <p>Join waitlist as a</p>
            <div className="border border-black text-[#570033] p-4 flex justify-between w-[90%] max-w-[400px] rounded-lg sm:text-sm">
              <p>User</p>
              <input
                type="checkbox"
                checked={formData.role === "user"}
                onChange={() => handleCheckboxChange("user")}
              />
            </div>

            <div className="border border-black text-[#570033] p-4 flex justify-between w-[90%] max-w-[400px] rounded-lg sm:text-sm">
              <p>Service Provider</p>
              <input
                type="checkbox"
                checked={formData.role === "serviceProvider"}
                onChange={() => handleCheckboxChange("serviceProvider")}
              />
            </div>
          </div>
        </form>

        <p className="text-center w-[90%] max-w-[400px] my-4 mx-auto text-sm sm:text-xs">
          Service Provider includes but not limited to Licensed car owners and
          drivers, travel assistant, accommodation expert, etc.
        </p>

        <button className="bg-[#570033] my-8 mx-auto flex justify-center text-white border-none w-[90%] max-w-[400px] py-4 rounded-md sm:text-sm" onClick={handleSubmit}>
          Join Waitlist
        </button>
      </div>
    </div>
  );
}

export default Waitlist;
